(function () {
  var faqAccordions = document.getElementsByClassName("faq-pdp__accordion");
  var i;

  for (i = 0; i < faqAccordions.length; i++) {
    faqAccordions[i].addEventListener("click", function() {
      this.classList.toggle("active-faq");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
})();